import { render, staticRenderFns } from "./projectsCollections.vue?vue&type=template&id=1a5ef6e6&scoped=true&"
import script from "./projectsCollections.vue?vue&type=script&lang=js&"
export * from "./projectsCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ef6e6",
  null
  
)

export default component.exports